import { useState } from "react";
import { assetUrl } from "../lib/assets";

/** Consistent public image URLs and a visible, accessible broken-image state. */
export default function AssetImage({ src, alt = "Image", merchantCode, fallback, className = "", onError, onLoad, ...props }) {
  const resolved = assetUrl(src, { merchantCode });
  const [result, setResult] = useState({ src: "", status: "loading" });
  const status = result.src === resolved ? result.status : "loading";
  if (!resolved || status === "error") return <span {...props} role="img" aria-label={`${alt} unavailable`} title={`${alt} unavailable`} data-asset-state="error" className={`inline-flex items-center justify-center bg-muted text-muted-foreground text-[10px] text-center overflow-hidden ${className}`}>{fallback || "Image unavailable"}</span>;
  return <img {...props} src={resolved} alt={alt} className={className} decoding="async" aria-busy={status !== "loaded"} data-asset-state={status}
    onLoad={event => { setResult({ src: resolved, status: "loaded" }); onLoad?.(event); }}
    onError={event => { setResult({ src: resolved, status: "error" }); onError?.(event); }} />;
}
